import {
  Button,
  Divider,
  Grid,
  IconButton,
  Paper,
  Tooltip,
  Typography,
} from "@mui/material";
import React, { useState } from "react";
import { WSIcons } from "../../../commonFunctions/iIcons";
import { useNavigate } from "react-router-dom";
import Footer from "../../TakeAway/FooterOrder";
import { MenuList } from "../../TakeAway/MenuList";
import { Course } from "../../TakeAway/Course";
import { SeatNumberModal } from "../../TakeAway/SeatNo";

export const OrderItem: React.FC<any> = React.memo((props) => {
  const navigate = useNavigate();
  const [openCourseDialog, setOpenCourseDialog] = useState(false);  
  const [openSeatNoDialog, setOpenSeatNoDialog] = useState(false);  
  const [selectedView, setSelectedView] = useState("current");
  const handleClick = (path: string) => {
    navigate(path);
  };
/**
 * Course Dialogue
 */
const handleCourseClick = () => {
    setOpenCourseDialog(true); 
  };

  const handleCourseClose = () => {
    setOpenCourseDialog(false); 
  };

  /**
   * Seat no dialogue
   */
  const handleSeatNoClick = () => {
    setOpenSeatNoDialog(true); 
  };

  const handleSeatNoClose = () => {
    setOpenSeatNoDialog(false); 
  };
  return (
    <Grid>
      <Grid sx={{ padding: 1 }}>
        <Grid container alignItems="center" spacing={2}>
          {/* Menu Button */}
          <Grid item xs={12} sm={4}>
            <Tooltip title="order info">
              <Button>
                <WSIcons.AlarmIcon sx={{ color: "black" }} />
              </Button>
            </Tooltip>
          </Grid>

          {/* Information (Table, Guest, Adult, Child) */}
          <Grid
            item
            xs={12}
            sm={6}
            sx={{ display: "flex", justifyContent: "center", gap: 20 }}
          >
            <Typography variant="body2">Table</Typography>
            <Typography variant="body2">Guest</Typography>
            <Typography variant="body2">Adult 0</Typography>
            <Typography variant="body2">Child 0</Typography>
          </Grid>

          {/* Spacer */}
          <Grid item xs />

          {/* Close Button */}
          <Grid item>
            <Button sx={{ backgroundColor: "red", color: "white" }}>
              <WSIcons.CloseIcon onClick={() => handleClick("/reservationinformation")} />
            </Button>
          </Grid>
        </Grid>
      </Grid>
      <Grid container direction="column">
        <Grid>
          <Grid container>
            <Grid item xs={12} sm={4}>
              {/* Icons Section at the Bottom */}
              <Grid item sx={{ backgroundColor: "white", marginTop: "30rem" }}>
                <Grid container spacing={2} sx={{ padding: 1 }}>
                  <Grid item>
                    <Tooltip title="change unit">
                      <IconButton>
                        <WSIcons.Dice />
                      </IconButton>
                    </Tooltip>
                  </Grid>
                  <Grid item>
                    <Tooltip title="change quantity">
                      <IconButton>
                        <WSIcons.FastfoodIcon />
                      </IconButton>
                    </Tooltip>
                  </Grid>
                  <Grid item>
                    <Tooltip title="Add modifier">
                      <IconButton>
                        <WSIcons.RestaurantIcon />
                      </IconButton>
                    </Tooltip>
                  </Grid>
                  <Grid item>
                    <Tooltip title="Preparation remark">
                      <IconButton>
                        <WSIcons.JuiceIcon />
                      </IconButton>
                    </Tooltip>
                  </Grid>
                  <Grid item>
                    <Tooltip title="Void Item">
                      <IconButton>
                        <WSIcons.CloseIcon />
                      </IconButton>
                    </Tooltip>
                  </Grid>
                  <Grid item>
                    <IconButton>
                      <WSIcons.KeyboardArrowUpIcon />
                    </IconButton>
                  </Grid>
                  <Grid item>
                    <IconButton>
                      <WSIcons.KeyboardArrowDownIcon />
                    </IconButton>
                  </Grid>
                </Grid>
              </Grid>
              <Grid item>
                <Grid container spacing={2} sx={{ padding: 1 }}>
                  <Grid item>
                    <Button
                      variant="outlined"
                      sx={{
                        backgroundColor: "white",
                        color: "black",
                        minWidth: "50px",
                      }}
                    >
                      1 <WSIcons.Car />
                    </Button>
                  </Grid>
                  <Grid item>
                    <Button
                      variant="outlined"
                      sx={{
                        backgroundColor: "white",
                        color: "black",
                        minWidth: "50px",
                      }}
                    >
                      1
                    </Button>
                  </Grid>
                  <Grid item>
                    <Button
                      variant="outlined"
                      sx={{
                        backgroundColor: "white",
                        color: "black",
                        minWidth: "50px",
                      }}
                    >
                      2
                    </Button>
                  </Grid>
                  <Grid item>
                    <Button
                      variant="outlined"
                      sx={{
                        backgroundColor: "white",
                        color: "black",
                        minWidth: "50px",
                      }}
                    >
                      3
                    </Button>
                  </Grid>
                  <Grid item>
                    <Button
                      variant="outlined"
                      sx={{
                        backgroundColor: "white",
                        color: "black",
                        minWidth: "50px",
                      }}
                    >
                      4
                    </Button>
                  </Grid>
                  <Grid item>
                    <Button
                      variant="outlined"
                      sx={{
                        backgroundColor: "white",
                        color: "black",
                        minWidth: "50px",
                      }}
                    >
                      +1
                    </Button>
                  </Grid>
                </Grid>
              </Grid>
              <Grid item>
                <Grid
                  container
                  spacing={2}
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    padding: 1,
                  }}
                >
                  <Grid item>Total</Grid>
                  <Grid item>
                    <Typography color={"red"} variant="h6">
                      {" "}
                      0.00{" "}
                    </Typography>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
            <Grid item xs={12} sm={8}>
              <MenuList selectedView={selectedView}/>
            </Grid>
            <Grid item xs={12}>
              <Grid
                sx={{
                  backgroundColor: "#333", 
                  padding: "10px",
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                }}
              >
                {/* Left Side - Icons */}
                <Grid container spacing={2} alignItems="center" gap={3}>
                  <Grid item>
                    <WSIcons.AppsIcon sx={{ color: "white" }} />
                  </Grid>
                  <Grid item>
                    <WSIcons.VisibilityIcon sx={{ color: "white" }} />
                  </Grid>
                  <Grid item>
                    <WSIcons.SearchIcon sx={{ color: "white" }} onClick={()=>handleClick('/itemsearch')}/>
                  </Grid>
                  <Grid item>
                    <WSIcons.RoomServiceIcon sx={{ color: "white" }} />
                  </Grid>
                  <Grid item>
                    <WSIcons.SoupKitchenIcon sx={{ color: "white" }} onClick={handleCourseClick} />
                  </Grid>
                  <Grid item>
                    <WSIcons.Chair sx={{ color: "white" }} onClick={handleSeatNoClick}/>
                  </Grid>
                  <Grid item>
                    <WSIcons.Tag sx={{ color: "white" }} />
                  </Grid>
                </Grid>

                {/* Right Side - Buttons */}
                <Grid  >
                  <Button
                    variant="contained"
                    sx={{
                      backgroundColor: "green",
                      "&:hover": {
                        backgroundColor: "#388e3c",
                      },
                    }}
                  >
                    Finish
                  </Button>
                </Grid>
              </Grid>{" "}
            </Grid>
          </Grid>
        </Grid>
      </Grid>
      <Course open={openCourseDialog}  onClose={handleCourseClose} />
      <SeatNumberModal open={openSeatNoDialog}  onClose={handleSeatNoClose}/>
    </Grid>
  );
});
